export default {
  stateKey: 'heading-h3',
  order: 2,
  isActiveKey: 'heading',
  commandKey: 'toggleHeading',
  commandProps: { level: 3 },
  icon: ['far', 'h3'],
  appearance: {
    menu: true,
    bubble: true,
  },
}
